export default __webpack_public_path__ + "static/media/FP_FM_GM.8ad9b3d1.png";